import { FC, useEffect, useMemo, useRef } from 'react'

import { CalendarShiftsList } from '@/containers/Calendar/subcomponents/CalendarShiftsList/CalendarShiftsList'
import { DayContent } from '@/containers/Calendar/subcomponents/DayContent/DayContent'
import { DayHeader } from '@/containers/Calendar/subcomponents/DayHeader/DayHeader'

import { filterShiftsByDays, getHeader } from './helpers'
import { DayBasis } from './models'

import './Day.scss'


interface DayProps extends DayBasis {
    day: Date
    index: number
    outOfRange: boolean
    showDate: boolean
}

export const Day: FC<DayProps> = ({
    day,
    shifts,
    showHeader,
    index,
    outOfRange,
    showDate,
}) => {
    const todayRef = useRef<HTMLDivElement>(null)
    const filteredShifts = useMemo(() => filterShiftsByDays(shifts, day), [shifts, day])
    const isToday = useMemo(() => new Date().toDateString() === day.toDateString(), [day])

    const header = getHeader(day)

    useEffect(() => {
        if (! todayRef.current) {
            return
        }

        todayRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }, [todayRef, isToday, shifts])

    return (
        <div
            ref={isToday ? todayRef : undefined}
            className={`day calendar-day ${outOfRange ? 'day--out-of-range' : ''}`}
            style={{ zIndex: (100 - index) }}
        >
            { showHeader && <DayHeader header={header} /> }
            <DayContent day={day} showHeader={showDate}>
                {!! (filteredShifts.length) && (
                    <CalendarShiftsList shifts={filteredShifts} />
                )}
            </DayContent>
        </div>
    )
}
